import { api } from './index';
import { omitBy } from 'lodash';
import { isNil } from 'utils';

const baseUrl = '/category_sections';
export default {
  getCategorySections(status) {
    const params = { status };
    return api.get(baseUrl, { params: omitBy(params, isNil) });
  },
  getCategoryChildren() {
    return api.get(`${baseUrl}/categories/children`);
  },
  getCategorySection(id) {
    return api.get(`${baseUrl}/${id}`);
  },
  updateCategorySection(id, payload) {
    return api.put(`${baseUrl}/${id}`, {
      category_section: payload,
    });
  },
  createCategorySection(payload) {
    return api.post(`${baseUrl}`, { category_section: payload });
  },
};
